import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";

/*import 'animate.css';*/
import projImg1 from "../assets/img/ProjectsImg/project-img1.png";
import projImg2 from "../assets/img/ProjectsImg/project-img2.png";
import projImg3 from "../assets/img/ProjectsImg/project-img3.png";
import projImg4 from "../assets/img/ProjectsImg/project-img4.png";
import projImg5 from "../assets/img/ProjectsImg/project-img5.png";
import projImg6 from "../assets/img/ProjectsImg/project-img6.png";
import projImg7 from "../assets/img/ProjectsImg/project-img7.png";
import projImg8 from "../assets/img/ProjectsImg/project-img8.png";
import projImg9 from "../assets/img/ProjectsImg/project-img9.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

    const projects = [
        {
            title: "Travel Agency",
            description: "Web application for managing travel packages, bookings, and customer information, focusing on usability and scalable backend architecture.",
            imgUrl: projImg1,
        },
        {
            title: "Educational System",
            description: "Platform designed to manage courses, students, and learning content with secure authentication and structured data management.",
            imgUrl: projImg2,
        },
        {
            title: "Business Startup",
            description: "Full-stack application built to support startup operations, including service presentation, data handling, and performance optimization.",
            imgUrl: projImg3,
        },
        {
            title: "Financial Control System",
            description: "System for tracking income, expenses, and financial reports, providing clear insights and reliable data persistence.",
            imgUrl: projImg4,
        },
        {
            title: "Schedule Manager",
            description: "Application for organizing schedules, appointments, and reminders with an intuitive interface and efficient data handling.",
            imgUrl: projImg5,
        },
        {
            title: "E-commerce",
            description: "Online store platform featuring product management, shopping cart, and order processing with secure and scalable backend services.",
            imgUrl: projImg6,
        },
        {
            title: "To-Do List",
            description: "Task management application that allows users to create, organize, and track tasks with persistent storage and a clean, user-friendly interface.",
            imgUrl: projImg7,
        },
        {
            title: "Inventory Management Application",
            description: "System designed to manage products, stock levels, and inventory operations, ensuring data consistency and efficient control of resources.",
            imgUrl: projImg8,
        },
        {
            title: "Streaming Video Entertainment Service",
            description: "Backend-oriented platform for managing video content, users, and streaming workflows, focusing on performance, scalability, and reliable data handling.",
            imgUrl: projImg9,
        },
]

    return (
        <section className="project" id="projects">
            <Container>
                <Row>
                    <Col size={12}>
                        <TrackVisibility>
                            {({ isVisible }) =>
                                <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                                    <h2>Projects</h2>
                                    <p>
                                        A selection of projects that showcase my experience in backend development, software architecture,
                                        and full-stack solutions. These projects reflect my ability to design, build, and deploy scalable
                                        applications using modern technologies and best practices.
                                    </p>
                                    <Tab.Container id="projects-tabs" defaultActiveKey="first">
                                        <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                                            <Nav.Item>
                                                <Nav.Link eventKey="first">Featured</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="second">Professional</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="third">Experiments</Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                        <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                                            <Tab.Pane eventKey="first">
                                                <Row>
                                                        {
                                                            projects.slice(0, 3).map((project, index) => {
                                                                return (
                                                                    <ProjectCard
                                                                        key={index}
                                                                        {...project}
                                                                    />
                                                                )
                                                            })
                                                        }
                                                </Row>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="second">
                                                <Row>
                                                    {
                                                        projects.slice(3, 6).map((project, index) => {
                                                            return (
                                                                <ProjectCard
                                                                    key={index}
                                                                    {...project}
                                                                />
                                                            )
                                                        })
                                                    }
                                                </Row>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="third">
                                                <Row>
                                                    {
                                                        projects.slice(6, 9).map((project, index) => {
                                                            return (
                                                                <ProjectCard
                                                                    key={index}
                                                                    {...project}
                                                                />
                                                            )
                                                        })
                                                    }
                                                </Row>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Tab.Container>
                                </div>}
                        </TrackVisibility>
                    </Col>
                </Row>
            </Container>
            <img className="background-image-right" src={colorSharp2}></img>
        </section>
    )
}